export const environment = {
  localEnv: false,
  htvApiUrl: 'https://api.dev.htv.humecloud.com',
  sentry: {
    environment: 'development',
    tracesSampleRate: 1.0,
  },
}
